import { datadogRum } from '@datadog/browser-rum';
import { createBeforeSend } from './dd-qa/before-send.js';
import { initUI } from './dd-qa/ui.js';
import { initInputTracker } from './dd-qa/input-tracker.js';
import { initLogSession, pushLog } from './dd-qa/log-store.js';
import { initErrorToast, showErrorToast } from './dd-qa/error-toast.js';
import './atqc';

if (process.env.FRONT_ENV === 'prod') {

  // GOOGLE TAG MANAGER
  (function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s), dl = l == 'dataLayer' ? '' : '&l=' + l; j.async = true; j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-PLMV3FF');
}

if (process.env.PENDO_KEY) {

  // PENDO
  (function (p, e, n, d, o) {
    var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || [];
    v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) {
      o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); };
    })(v[w]);
    y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + process.env.PENDO_KEY + '/pendo.js';
    z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);
  })(window, document, 'script', 'pendo');
}

if (process.env.DATADOG_APP_ID) {

  // DATADOG
  datadogRum.init({
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    applicationId: process.env.DATADOG_APP_ID,
    site: process.env.DATADOG_SITE,
    service: 'overhaul-frontend',
    // Specify a version number to identify the deployed version of your application in Datadog
    version: `${process.env.APP_VERSION}-${process.env.BUILD_NUMBER}`,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    env: process.env.FRONT_ENV,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [/https:\/\/(?!.*zitadel).*\.over-haul\.com/], //disallow zitadel because of CORS issues
    enableExperimentalFeatures: ['clickmap'],
    beforeSend: createBeforeSend({ onError: (process.env.FRONT_ENV === 'dev') ? showErrorToast : undefined }),
  });

  if (process.env.FRONT_ENV === 'dev') {
    initLogSession(datadogRum.getInternalContext?.()?.session_id);
    initErrorToast(process.env.DATADOG_SITE);
    const _t = new Date().toISOString();
    const _navType = performance.getEntriesByType?.('navigation')?.[0]?.type;
    const _label = _navType === 'reload'
      ? `Page reloaded (${window.location.href})`
      : `Page loaded (${window.location.href})`;
    pushLog({ t: _t, type: 'nav', label: _label, url: window.location.href });
    initUI(process.env.DATADOG_SITE);
    initInputTracker();
  }
}

